/**
 * @generated SignedSource<<9fc8c5adc5d433ff49e3d357e9983046>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SuppressTimeRegOutsideProjectPeriodWarningInput = {
  projectId: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type suppressTimeRegOutsideProjectPeriodWarningMutation$variables = {
  input: SuppressTimeRegOutsideProjectPeriodWarningInput;
};
export type suppressTimeRegOutsideProjectPeriodWarningMutation$data = {
  readonly suppressTimeRegOutsideProjectPeriodWarning: {
    readonly clientMutationId: string | null;
  } | null;
};
export type suppressTimeRegOutsideProjectPeriodWarningMutation = {
  variables: suppressTimeRegOutsideProjectPeriodWarningMutation$variables;
  response: suppressTimeRegOutsideProjectPeriodWarningMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SuppressTimeRegOutsideProjectPeriodWarningPayload",
    "kind": "LinkedField",
    "name": "suppressTimeRegOutsideProjectPeriodWarning",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "suppressTimeRegOutsideProjectPeriodWarningMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "suppressTimeRegOutsideProjectPeriodWarningMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3de55a1127c6a7fc14389bfeca1cf267",
    "id": null,
    "metadata": {},
    "name": "suppressTimeRegOutsideProjectPeriodWarningMutation",
    "operationKind": "mutation",
    "text": "mutation suppressTimeRegOutsideProjectPeriodWarningMutation(\n  $input: SuppressTimeRegOutsideProjectPeriodWarningInput!\n) {\n  suppressTimeRegOutsideProjectPeriodWarning(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();

(node as any).hash = "1bdb276993b1a24d6c34f5927ea00c16";

export default node;
